import { AxiosInstance } from "axios";
import { saveByteArray } from "src/util/saveByteArray";
import { IBCheckBatch } from "../interface/bcheck/IBCheckBatch";
import { IBCheckBatchRequest } from "../interface/bcheck/IBCheckBatchRequest";
import IBaseResponse from "../interface/IBaseResponse";
import { ApiService } from "../model/Api.model";

enum BCheckBatchServiceEnum {
  base = "/",
  downloadHits = "/download-hits/"
}

export class BCheckBatchService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/bcheck/batch");
  }

  public getBCheckBatchs = async (): Promise<IBCheckBatch[]> => await this.GET(BCheckBatchServiceEnum.base);
  public entubaBCheckBatch = async (requesst: IBCheckBatchRequest): Promise<IBaseResponse> => await this.POST(BCheckBatchServiceEnum.base, requesst);
  public getBCheckBatchById = async (id: number): Promise<IBCheckBatch> => await this.GET(BCheckBatchServiceEnum.base + id);
  public downloadHitByBatchId = async (id: number): Promise<any> => {
    const data = await this.GET(BCheckBatchServiceEnum.downloadHits + id, "blob");
    const filename = `bcheck_${id}.zip`;
    saveByteArray(filename, data);
    return data;
  };
}



// WEBPACK FOOTER //
// ./src/services/api/BCheckBatch.service.ts